import ReviewIcon from '@mui/icons-material/Comment';
import ReviewList from './ReviewList';

export default {
    icon: ReviewIcon,
    list: ReviewList,
};
